// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import promise from 'es6-promise'
promise.polyfill()
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import httpRequest from '../utils/https'

// 挂载全局
Vue.prototype.$http = httpRequest // ajax请求方法

Vue.config.productionTip = false

window.SITE_CONFIG = {}
// api接口请求地址
// window.SITE_CONFIG['baseUrl'] = 'https://backend-api.arccer.com/renren-fast';
window.SITE_CONFIG['baseUrl'] = 'https://arccerapi-bhcozevcmt.cn-shanghai.fcapp.run/renren-fast';
// window.SITE_CONFIG['baseUrl'] = 'http://106.15.191.213:18080/renren-fast';

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js